import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Select,
  MenuItem,
  Checkbox,
  Typography,
  Tooltip,
  Menu,
  FormControl,
  InputLabel,
  IconButton,
  Box,
  TableSortLabel,
  TextField,
} from "@mui/material";
import { MODEL_LISTING_COLUMNS } from "../../utils/constant";
import RecordNotFound from "../../common/RecordNotFound";
import SearchIcon from "@mui/icons-material/Search";
import AddModel from "./AddModel";

import { useNavigate, Link } from "react-router-dom";
import Add from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FilterAltOffSharpIcon from "@mui/icons-material/FilterAltOffSharp";
import download from "downloadjs";
import { visuallyHidden } from "@mui/utils";
import DownloadIcon from "@mui/icons-material/Download";
import {
  ModelChangeStatusService,
  onEditModelService,
  onAddModelService,
} from "../../services/ModelViewService";
import useGlobalState from "../../Context";
import {
  setModelSearchBrand,
  setModelSearchBrick,
  setModelSearchModel,
} from "../../reducer/action";

const ModelList = ({
  handleTableChanges,
  modelRecords,
  brickList,
  fetchBrandsList,
  fetchModelDetails,
  totalElements,
  brandList,
  setLoading,
  showNotification,
  fetchBrickListWithorWithoutFamily,
  brandListOnBrickId,
  brickListOnBrandId,
  fetchCategoryListOnSelectedBrand,
  categoryListOnBrandId,
  setModelRecords,
  productFamilyList,
  downloadModelDetails,
  noRecord,
  categoryList,
  fetchProductFamilyList,
  onBrandClick,
  onBrickClick,
  setDisableSearchButton,
  setdisableFilterButton,
  searchedRows,
  reset,
  formData,
  setFormData,
  setDisableDownloadButton,
  brandSearch,
  brickSearch,
  disableFilterButton,
  onClearClick,
  disableDownloadButton,
  disableSearchButton,
  register,
  handleSubmit,
  errors,
  searchModelNameValue,
  setSearchModelNameValue,
  page,
  maxPage,
  setPage,
  setMaxPage,
  searchOnClick,
  handleActiveChange,
  disableUpdateButton,
  selected,
  setSelected,
  setDisbaleUpdateButton,
  setValue,
  setCategoryListOnBrandId,
  rowsPerPage,
  setRowsPerPage,
}) => {
  //const [{brandSearchv,brickSearchv,searchModelNameValuev}, dispatch] = useGlobalState();
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [searchwith, setSearchwith] = useState("");
  const [openAddModelDialog, setOpenAddModelDialog] = useState(false);
  const [modelId, setModelId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [brickId, setBrickId] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [familyName, setFamilyName] = useState("");
  const [brickName, setBrickName] = useState("");
  const [isUpdateButton, setIsUpdateButton] = useState(true);
  const [slcRow, setSlcRow] = React.useState(null);
  const [sortValue, setSortValue] = useState("ASC");
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("modelName");
  const [anchorEl, setAnchorEl] = useState(null);

  const [disableCategoryDropdown, setDisableCategoryDropdown] = useState(true);
  const [disableFamilyDropdown, setDisableFamilyDropdown] = useState(true);
  const [disableBrickDropdown, setDisableBrickDropdown] = useState(true);
  const [isSearchBtnClick, setIsSearchBtnClick] = useState(false);
  // const auth = JSON.parse(localStorage.getItem("SPMS_INTERNAL_STATE"));
  const [
    {
      auth,
      spareAccessRights,
      brandSearchv,
      brickSearchv,
      searchModelNameValuev,
    },
    dispatch,
  ] = useGlobalState();
  const loginUserInfo = auth.ldapParam;
  // const [brandSearchv, setBrandSearchv] = useState(null);
  // const [brickSearchv, setBrickSearchv] = useState(null);
  // const [searchModelNameValuev,setSsearchModelNameValuev] = useState(null);
  const [formValues, setFormValues] = useState({
    createdOn: new Date(),
    createdBy: loginUserInfo.userId,
    modifiedBy: loginUserInfo.userId,
  });
  const open = Boolean(anchorEl);
  const handleClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSlcRow(row);
  };

  const resetDefalutVal = async () => {};
  const handlspareListItem = (e, itemAction) => {
    let row = slcRow;
    setAnchorEl(null);
    if (itemAction === "view") {
      navigate(`/model-search/model-view`, {
        state: {
          modelId: row?.modelId,
          brandName: row?.brandName,
          modelCode: row?.modelCode,
          // sortBy:orderBy,
          //  isAsc:"ASC",
          //  brandSearch:brandSearchv,
          //  brickSearch:brickSearchv,
          //  searchModelNameValue:searchModelNameValuev,
          //  paginationObject:{
          //   pageNumber:0,
          //   pageSize:10
          //  }
        },
      });
    } else if (itemAction === "edit") {
      handleClickOpen(row);
      //navigate(`/spare-view/${row?.spareId}`);
    } else {
      console("error in model extra listing menu");
    }
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  const handleClickOpen = async (item, e) => {
    if (item) {
      reset(item);
    }
    setDisableCategoryDropdown(false);
    setDisableFamilyDropdown(false);
    setDisableBrickDropdown(false);
    setOpenAddModelDialog(true);
    fetchBrandsList();
    fetchCategoryListOnSelectedBrand(item?.brandId);
    fetchBrickListWithorWithoutFamily(item.productCatFamilyMappingId);
    fetchProductFamilyList(item?.productCategoryId);
    setIsEditMode(true);
    setBrickId(item?.brickId);
    setModelId(item?.modelId);
    setBrandName(item?.brandName);
    setBrickName(item?.brickName);
    setFamilyName(item?.productFamilyName);
    setFormValues({
      createdOn: item?.createdOn,
      createdBy: item?.createdBy ?? 1,
      modifiedBy: item?.modifiedBy,
      active: item?.isActive ? true : false,
    });
    setFormData({ ...item });
    //console.log('setFormData', formData)
  };

  const handleClickOpenOnAdd = async () => {
    setOpenAddModelDialog(true);
    setDisableCategoryDropdown(true);
    setDisableFamilyDropdown(true);
    setDisableBrickDropdown(true);
    await fetchBrandsList();
    // fetchProductFamilyList();
  };

  useEffect(() => {
    reset(formData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAddModelDialog]);

  const handleClose = () => {
    setOpenAddModelDialog(false);
    setIsEditMode(false);
    setModelId(null);
    setIsUpdateButton(true);
    setFormData({});
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - modelRecords.length) : 0;

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };

    await handleTableChanges(
      paginationValues,
      false,
      sortValue,
      orderBy,
      brandSearchv,
      brickSearchv,
      searchModelNameValuev
    );
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleTableChanges(
        paginationValues,
        true,
        sortValue,
        orderBy,
        brandSearchv,
        brickSearchv,
        searchModelNameValuev
      );
    }
    setPage(newPage);
  };

  const searchText = async (e) => {
    setSearchModelNameValue(e.target.value);
    // if(e.target.value.trim() === ""  &&
    // brandSearch === null &&
    // brickSearch === null){
    //   setDisableSearchButton(true);
    //   setdisableFilterButton(true);
    //   setDisableDownloadButton(true);

    // }
    if (e.target.value === "" && brandSearch === null && brickSearch === null) {
      onClearModelClick();
      // await fetchModelDetails("modelName", true);
      // // eslint-disable-next-line no-unused-expressions
      // setPage(0);
      // setMaxPage(0);
      // setDisableSearchButton(true);
      // setdisableFilterButton(true);
      // setDisableDownloadButton(true);
    } else {
      if (e.target.value.trim().length > 0) {
        setDisableSearchButton(false);
        setdisableFilterButton(false);
      }
    }
  };

  const onCategoryClick = async (id, cateName) => {
    setDisableFamilyDropdown(false);
    setDisableBrickDropdown(true);
    setValue("productCatFamilyMappingId", "");
    setValue("brickId", "");
    await fetchProductFamilyList(id);
  };

  const onFamilyClick = async (id, name) => {
    setFamilyName(name);
    setValue("brickId", "");
    setDisableBrickDropdown(false);
    await fetchBrickListWithorWithoutFamily(id);
  };

  const onBrandSelectedClick = async (id, name) => {
    reset((formValues) => ({ ...formValues, productCategoryId: "" }));
    setFormData({});
    setBrandName(name);
    setDisableCategoryDropdown(false);
    setDisableFamilyDropdown(true);
    setDisableBrickDropdown(true);
    await fetchCategoryListOnSelectedBrand(id);
    setValue("productCategoryId", "");
    setValue("productCatFamilyMappingId", "");
    setValue("brickId", "");
    //setCategoryListOnBrandId([])
  };

  const onAddEditModelSubmit = async (data) => {
    try {
      let obj = {
        modelCode: data.modelName,
        fgCode: data.modelName ?? "",
        shortName: data.shortName.trim() ?? "",
        modelDesc: data.modelDesc.trim() ?? "",
        modelName: data.modelName.trim() ?? "",
        brandID: parseInt(data.brandId) ?? null,
        productFamilyId: parseInt(data.productCatFamilyMappingId) ?? null,
        active: formValues.active ? true : false,
        brickId: parseInt(data.brickId) ?? null,
        modelId,

        createdOn: formValues.createdOn,
        createdBy: formValues.createdBy,
        modifiedOn: formValues.createdOn,
        modifiedBy: formValues.modifiedBy,
      };

      const res = !isEditMode
        ? await onAddModelService(obj)
        : await onEditModelService(obj);
      // console.log('response',res)
      if (res.statusCode === 6) {
        const newModelRecords = [...modelRecords];
        const index = newModelRecords.findIndex((x) => x.modelId === modelId);
        newModelRecords[index] = { ...modelRecords[index], ...obj };
        setModelRecords(newModelRecords);
        handleClose(false);
        setIsUpdateButton(true);
        setSelected([]);
        setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
        onClearModelClick();
        // if (!isEditMode) {
        //   setPage(0);
        //   setMaxPage(0);
        //   const paginationValues = {
        //     pageNumber: 0,
        //     pageSize: 10,
        //   };
        //   await fetchModelDetails("modelName", true,null,null,null,paginationValues);
        // }
      } else {
        // handleClose(true);
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      throw err;
    }
  };

  const onChangeStatusSubmit = async () => {
    // console.log("inside sub");
    const resultRecords = [];
    selected.forEach((itemId) => {
      const tempItem = modelRecords?.find(
        (record) => record.modelId === itemId
      );
      if (tempItem) {
        resultRecords.push({
          active: tempItem.isActive,
          modelId: tempItem.modelId,
        });
      }
    });
    try {
      const res = await ModelChangeStatusService(resultRecords);
      if (res.statusCode === 6) {
        // await fetchModelDetails("modelName", true);
        setSelected([]);
        setDisbaleUpdateButton(true);
        showNotification("Success", res.message, "success");
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (e) {
    } finally {
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    setSelected([]);
    setDisbaleUpdateButton(true);
    const paginationValues = {
      pageNumber: 0,
      pageSize: rowsPerPage,
    };
    fetchModelDetails(
      property,
      isAsc,
      brandSearchv,
      brickSearchv,
      searchModelNameValuev,
      paginationValues
    );
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
  };

  const searchModelOnClick = (searchModelNameValue) => {
    dispatch(setModelSearchBrand(brandSearch));
    dispatch(setModelSearchBrick(brickSearch));
    dispatch(setModelSearchModel(searchModelNameValue));
    // setBrandSearchv(brandSearch);
    // setBrickSearchv(brickSearch);
    // setSsearchModelNameValuev(searchModelNameValue);
    const requestBody = {
      pageNumber: 0,
      pageSize: rowsPerPage ?? 10,
    };
    setIsSearchBtnClick(true);
    searchOnClick(searchModelNameValue, requestBody);
    setSelected([]);
    setDisbaleUpdateButton(true);
    setPage(0);
    setMaxPage(0);
  };

  const onClearModelClick = () => {
    dispatch(setModelSearchBrand(null));
    dispatch(setModelSearchBrick(null));
    dispatch(setModelSearchModel(null));
    // setBrandSearchv(null);
    // setBrickSearchv(null);
    // setSsearchModelNameValuev(null);
    const paginationData = {
      pageNumber: 0,
      pageSize: rowsPerPage ?? 10,
    };
    setIsSearchBtnClick(false);
    setSelected([]);
    setDisbaleUpdateButton(true);
    setDisableDownloadButton(true);
    onClearClick(paginationData);
  };

  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 8 }}>
        {/* <Paper elevation={4} sx={{ width: "100%", overflow: "hidden" }}> */}
        <Grid container spacing={0} sx={{ px: 0, mt: 0 }} display="flex">
          <Grid item xs={4} sx={{ mb: 1 }}>
            <Typography
              align="left"
              sx={{ mr: "auto", color: "#003f93" }}
              variant="h6">
              Model Search ( {totalElements ? totalElements : 0} )
            </Typography>
          </Grid>
          <Grid item xs={8} sx={{ mb: 1 }}>
            <Typography align="right">
              {spareAccessRights.addDelete ? (
                <Tooltip title="Add Model">
                  <Button
                    variant="contained"
                    onClick={() => {
                      handleClickOpenOnAdd();
                    }}
                    className="button-primary-alt-contained"
                    startIcon={<Add />}>
                    Add Model
                  </Button>
                </Tooltip>
              ) : null}
              {//loginUserInfo.rilUser ? (
                <Tooltip title="Download Model Details">
                  <Button
                    variant="contained"
                    className="button-primary-alt-contained"
                    startIcon={<DownloadIcon />}
                   // disabled={disableDownloadButton}
                    sx={{ ml: 1 }}
                    onClick={async () => {
                      try {
                        setLoading(true);
                        console.log("brandSearchv-->"+brandSearchv+"  brickSearchv-->"+brickSearchv+"  searchModelNameValuev-->"+searchModelNameValuev)
                        const obj = {
                          brandId: brandSearchv ??brandSearchv ?? null,
                          brickId: brickSearchv ?? brickSearchv ?? null,
                          modelName: searchModelNameValuev ?? searchModelNameValuev ?? null,
                          active:
                            loginUserInfo.userType === "Main Admin" ? 2 : 0,
                        };
                        const response = await downloadModelDetails(obj);
                        const content = response.headers["content-type"];
                        download(response.data, "modelList.csv", content);
                      } catch (err) {
                        console.log("errrr-->"+err)
                        showNotification("Error", "Failed To Fetch--"+err);
                      } finally {
                        setLoading(false);
                      }
                    }}>
                    Download
                  </Button>
                </Tooltip>
              //) : null
            }
              {spareAccessRights.addDelete ? (
                <Tooltip title="Update Model Status">
                  <Button
                    variant="contained"
                    sx={{ ml: 1 }}
                    className="button-primary-alt-contained"
                    onClick={onChangeStatusSubmit}
                    disabled={disableUpdateButton}>
                    Status Update
                    {selected.length !== 0 &&
                      ` (${Object.keys(selected).length})`}
                  </Button>
                </Tooltip>
              ) : null}
            </Typography>
          </Grid>
          <Grid item xs={12} md={12} sx={{ mb: 0 }}>
            <Typography align="left">
              <div className="searchContainer">
                {/* <FormLabel sx={{ width: "50px" }}>Brand</FormLabel> */}

                <FormControl sx={{ m: 1, minWidth: 200, ml: 0 }} size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    shrink={
                      brandSearch === null || (brandSearch !== null && true)
                    }>
                    <span className="searchFields"> Brand </span>
                  </InputLabel>
                  <Select
                    name="brandId"
                    autoComplete="off"
                    label="Brand"
                    value={brandSearch}>
                    {brandListOnBrickId &&
                      brandListOnBrickId.map((d) => {
                        return (
                          <MenuItem
                            native
                            key={d.brandId}
                            onClick={() => onBrandClick(d.brandId)}
                            sx={{ width: "100%" }}
                            value={d.brandId}
                            size="small">
                            {d.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
                  <InputLabel
                    id="demo-simple-select-label"
                    shrink={
                      brickSearch === null || (brickSearch !== null && true)
                    }>
                    <span className="searchFields"> Brick </span>
                  </InputLabel>
                  <Select
                    name="brickId"
                    autoComplete="off"
                    label="Brick"
                    value={brickSearch}>
                    {brickListOnBrandId &&
                      brickListOnBrandId.map((d) => {
                        return (
                          <MenuItem
                            native
                            key={d.brickId}
                            onClick={() => onBrickClick(d.brickId)}
                            sx={{ width: "100%" }}
                            value={d.brickId}
                            size="small">
                            {d.brickName}
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
                <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
                  <TextField
                    className="stepperFormInput"
                    label="Model Name\Description"
                    onChange={searchText}
                    InputLabelProps={{ shrink: true }}
                    value={searchModelNameValue}
                    size="small"
                    autoComplete="off"
                    onBlur={(e) => {
                      let str = e.target.value;
                      setSearchModelNameValue(str.trim());
                      if (
                        str.trim().length <= 0 &&
                        brandSearch === null &&
                        brickSearch === null
                      ) {
                        setDisableSearchButton(true);
                        setdisableFilterButton(true);
                        setDisableDownloadButton(true);
                      }
                      //setValue("brandName", str.trim());
                    }}
                  />
                </FormControl>

                <Tooltip title="Search">
                  <IconButton
                    color="primary"
                    aria-label="Search"
                    component="label"
                    disabled={disableSearchButton}>
                    <SearchIcon
                      sx={{ height: "35px", width: "35px" }}
                      onClick={() => searchModelOnClick(searchModelNameValue)}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Clear Search">
                  <IconButton
                    color="primary"
                    aria-label="Clear"
                    component="label"
                    disabled={disableFilterButton}>
                    <FilterAltOffSharpIcon
                      sx={{ height: "35px", width: "35px" }}
                      onClick={() => {
                        onClearModelClick();
                        setPage(0);
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>
            </Typography>
          </Grid>
          <Grid item xs={12} mb={2}>
            {/* {searchedRows && searchedRows.length > 0 ? ( */}
            <Paper sx={{ width: "100%", overflow: "hidden" }}>
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  stickyHeader
                  aria-label="sticky table"
                  // sx={{ minWidth: 750 }}
                  aria-labelledby="tableTitle"
                  size="small">
                  <EnhancedTableHead
                    numSelected={selected.length}
                    rowCount={searchedRows?.length}
                    onRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                    spareAccessRights={spareAccessRights}
                  />
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          const isItemSelected = isSelected(row.modelId);
                          const labelId = `enhanced-table-checkbox-${index}`;
                          return (
                            <TableRow
                              tabIndex={-1}
                              hover
                              role="checkbox"
                              aria-checked={isItemSelected}
                              selected={isItemSelected}
                              key={row.modelId}
                              // onClick={() => onRowClick(row.modelId)}
                            >
                              <TableCell size="small" key={"brandName"}>
                                {`${row["brandName"]}` ?? "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                key={"productFamilyName"}>
                                {row["productFamilyName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"brickName"}>
                                {row["brickName"] ?? "-"}
                              </TableCell>
                              <TableCell size="small" key={"fgCode"}>
                                {row["fgCode"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                key={"modelDesc"}
                                title={row?.modelDesc ? row.modelDesc : ""}>
                                {/* {row["modelDesc"] ?? "-"} */}
                                {(row.modelDesc &&
                                  row.modelDesc?.slice(0, 20)) ||
                                  "-"}
                                {row.modelDesc && row.modelDesc.length > 20
                                  ? "..."
                                  : ""}{" "}
                              </TableCell>
                              {spareAccessRights.addDelete ? (
                                <TableCell align="center">
                                  {" "}
                                  <Checkbox
                                    color="primary"
                                    checked={(isItemSelected, row.isActive)}
                                    classes={{ root: "custom-checkbox-root" }}
                                    onChange={(event) =>
                                      handleActiveChange(event, row.modelId)
                                    }
                                    inputProps={{
                                      "aria-labelledby": labelId,
                                    }}
                                  />
                                </TableCell>
                              ) : null}

                              <TableCell>
                                <MoreVertIcon
                                  //className="profileEdit"
                                  color="primary"
                                  onClick={(event) => {
                                    handleClick(event, row);
                                  }}
                                  fontSize="small"
                                />
                                <Menu
                                  id="basic-menu"
                                  className="listingPopOver"
                                  anchorEl={anchorEl}
                                  open={open}
                                  onClose={handleCloseMenu}
                                  MenuListProps={{
                                    "aria-labelledby": "basic-button",
                                  }}>
                                  <MenuItem
                                    onClick={(e) => {
                                      handlspareListItem(e, "view");
                                    }}>
                                    <VisibilityIcon
                                      fontSize="medium"
                                      color="disabled"
                                      sx={{ mr: 1 }}
                                    />
                                    {/* <Link to="/model-view"> Linked Spares</Link> */}
                                    Linked Spares
                                  </MenuItem>
                                  {spareAccessRights.write ? (
                                    <MenuItem
                                      onClick={(e) => {
                                        handlspareListItem(e, "edit");
                                      }}>
                                      <EditIcon
                                        fontSize="medium"
                                        color="disabled"
                                        sx={{ mr: 1 }}
                                      />
                                      Edit
                                    </MenuItem>
                                  ) : null}
                                </Menu>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      {emptyRows > 0 && (
                        <TableRow
                          style={{
                            height: 33 * emptyRows,
                          }}>
                          <TableCell colSpan={7} />
                        </TableRow>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={7}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={7} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddModel
              openDialog={openAddModelDialog}
              handleClose={handleClose}
              fetchModelDetails={fetchModelDetails}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              onFamilyClick={onFamilyClick}
              brickList={brickList}
              isEditMode={isEditMode}
              formData={formData}
              brandList={brandList}
              onAddEditModelSubmit={onAddEditModelSubmit}
              brickId={brickId}
              onBrandSelectedClick={onBrandSelectedClick}
              categoryListOnBrandId={categoryListOnBrandId}
              setBrickName={setBrickName}
              productFamilyList={productFamilyList}
              isUpdateButton={isUpdateButton}
              setIsUpdateButton={setIsUpdateButton}
              categoryList={categoryList}
              onCategoryClick={onCategoryClick}
              disableCategoryDropdown={disableCategoryDropdown}
              disableFamilyDropdown={disableFamilyDropdown}
              disableBrickDropdown={disableBrickDropdown}
              resetDefalutVal={resetDefalutVal}
              setCategoryListOnBrandId={setCategoryListOnBrandId}
              setValue={setValue}
            />
          </Grid>
        </Grid>
        {/* </Paper> */}
      </Container>
    </>
  );
};

export default ModelList;

function EnhancedTableHead({
  onRequestSort,
  order,
  orderBy,
  spareAccessRights,
}) {
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };
  return (
    <TableHead>
      <TableRow key={"1"}>
        {MODEL_LISTING_COLUMNS.map((headCell) => (
          <TableCell
            size="small"
            variant="head"
            className="tableHeader1"
            sx={{ pt: 1.5, pb: 1.5 }}
            key={headCell.modelId}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            style={{
              minWidth: headCell.minWidth,
              // backgroundColor: "lightgray",
              fontWeight: "bold",
              color: "#003A6B",
            }}
            sortDirection={orderBy === headCell.id ? order : false}
            hidden={
              spareAccessRights.addDelete === false
                ? headCell.id === "active"
                  ? true
                  : false
                : false
            }>
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
              disabled={
                (headCell.id === "action" ||
                  headCell.id === "active" ||
                  headCell.id === "modelDesc" ||
                  headCell.id === "") &&
                true
              }>
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
